export default __webpack_public_path__ + "static/char-56-anr-a02a48e50a3e67be557f8a0f03df3258.webp";